module.exports = __webpack_public_path__ + "static/media/fvs_salaMendoza_5.0dd0af61.jpg";